import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=7479c8cc&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=7479c8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479c8cc",
  null
  
)

export default component.exports